// Pangrams for font samples
const pangrams = [
  "Nymphs blitz quick vex dwarf jog. DJs flock by when MTV ax quiz prog.",
  "DJs flock by when MTV ax quiz prog. Big fjords vex quick waltz nymph.",
  "Big fjords vex quick waltz nymph. Bawds jog, flick quartz, vex nymph.",
  "Bawds jog, flick quartz, vex nymph. Waltz job vexed quick frog nymphs.",
  "Waltz job vexed quick frog nymphs. Junk MTV quiz graced by fox whelps.",
  "Junk MTV quiz graced by fox whelps. Waltz, bad nymph, for quick jigs vex!",
  "Waltz, bad nymph, for quick jigs vex! Bright vixens jump; dozy fowl quack.",
  "Bright vixens jump; dozy fowl quack. Vexed nymphs go for quick waltz job.",
  "Vexed nymphs go for quick waltz job. Quick zephyrs blow, vexing daft Jim.",
  "Quick zephyrs blow, vexing daft Jim. Sphinx of black quartz, judge my vow!",
  "Sphinx of black quartz, judge my vow! Both fickle dwarves jinx my pig quiz.",
  "Both fickle dwarves jinx my pig quiz. Fat hag dwarves quickly zap jinx mob.",
  "Fat hag dwarves quickly zap jinx mob. Hick dwarves jam blitzing foxy quip.",
  "Old dwarves jam blitzing foxy quip. Fox dwarves chop my talking quiz job.",
  "Fox dwarves chop my talking quiz job. Public junk dwarves quiz mighty fox.",
  "Public junk dwarves quiz mighty fox. Jack fox bids ivy-strewn phlegm quiz.",
  "Jack fox bids ivy-strewn phlegm quiz. How quickly daft jumping zebras vex.",
  "How quickly daft jumping zebras vex. Two driven jocks help fax my big quiz.",
  "Two driven jocks help fax my big quiz. Show mangled quartz flip vibe exactly.",
  "Show mangled quartz flip vibe exactly. My ex pub quiz crowd gave joyful thanks.",
  "My ex pub quiz crowd gave joyful thanks. Cozy sphinx waves quart jug of bad milk.",
  "Cozy sphinx waves quart jug of bad milk. Jackdaws love my big sphinx of quartz.",
  "Jackdaws love my big sphinx of quartz. Pack my box with five dozen liquor jugs.",
  "Pack my box with five dozen liquor jugs. Few quips galvanized the mock jury box.",
  "Few quips galvanized the mock jury box. Quilt frenzy jackdaw gave them best pox.",
  "Quilt frenzy jackdaw gave them best pox. Jumpy halfling dwarves pick quartz box.",
  "Jumpy halfling dwarves pick quartz box. Vex quest wizard, judge my backflop hand.",
  "Vex quest wizard, judge my backflop hand. The jay, pig, fox, zebra and my wolves quack!",
  "The jay, pig, fox, zebra and my wolves quack! Blowzy red vixens fight for a quick jump.",
  "Blowzy red vixens fight for a quick jump. The quick brown fox jumps over a lazy dog.",
  "The quick brown fox jumps over a lazy dog. Quizzical twins proved my hijack-bug fix.",
  "Quizzical twins proved my hijack-bug fix. Fix problem quickly with galvanized jets.",
  "Fix problem quickly with galvanized jets. When zombies arrive, quickly fax judge Pat.",
  "When zombies arrive, quickly fax judge Pat. Heavy boxes perform quick waltzes and jigs.",
  "Heavy boxes perform quick waltzes and jigs. A wizard's job is to vex chumps quickly in fog.",
  "A wizard's job is to vex chumps quickly in fog. Pack my red box with five dozen quality jugs.",
  "Pack my red box with five dozen quality jugs. Fake bugs put in wax jonquils drive him crazy.",
  "Fake bugs put in wax jonquils drive him crazy. Who packed five dozen old quart jugs in my box?",
  "Who packed five dozen old quart jugs in my box? Woven silk pyjamas exchanged for blue quartz.",
  "Woven silk pyjamas exchanged for blue quartz. Brawny gods just flocked up to quiz and vex him.",
  "Brawny gods just flocked up to quiz and vex him. Twelve ziggurats quickly jumped a finch box.",
  "Twelve ziggurats quickly jumped a finch box. Prating jokers quizzically vexed me with fibs.",
  "Prating jokers quizzically vexed me with fibs. My faxed joke won a pager in the cable TV quiz show.",
  "My faxed joke won a pager in the cable TV quiz show. The quick onyx goblin jumps over the lazy dwarf.",
  "The quick onyx goblin jumps over the lazy dwarf. The lazy major was fixing Cupid's broken quiver.",
  "The lazy major was fixing Cupid's broken quiver. Amazingly few discotheques provide jukeboxes.",
  "Amazingly few discotheques provide jukeboxes. Jacky can now give six big tips from the old quiz.",
  "Jacky can now give six big tips from the old quiz. Lovak won the squad prize cup for sixty big jumps.",
  "Lovak won the squad prize cup for sixty big jumps. Cozy lummox gives smart squid who asks for job pen.",
  "Cozy lummox gives smart squid who asks for job pen. Painful zombies quickly watch a jinxed graveyard.",
  "Painful zombies quickly watch a jinxed graveyard. As quirky joke, chefs won't pay devil magic zebra tax.",
  "As quirky joke, chefs won't pay devil magic zebra tax. My girl wove six dozen plaid jackets before she quit.",
  "My girl wove six dozen plaid jackets before she quit. Grumpy wizards make a toxic brew for the jovial queen.",
  "Grumpy wizards make a toxic brew for the jovial queen. Sixty zips were quickly picked from the woven jute bag.",
  "Sixty zips were quickly picked from the woven jute bag. Big July earthquakes confound zany experimental vow.",
  "Big July earthquakes confound zany experimental vow. A very big box sailed up then whizzed quickly from Japan.",
  "A very big box sailed up then whizzed quickly from Japan. Jack quietly moved up front and seized the big ball of wax.",
  "Jack quietly moved up front and seized the big ball of wax. Few black taxis drive up major roads on quiet hazy nights.",
  "Few black taxis drive up major roads on quiet hazy nights. Just poets wax boldly as kings and queens march over fuzz.",
  "Just poets wax boldly as kings and queens march over fuzz. Crazy Frederick bought many very exquisite opal jewels.",
  "Crazy Frederick bought many very exquisite opal jewels. A quivering Texas zombie fought republic linked jewelry.",
  "A quivering Texas zombie fought republic linked jewelry. Happy wizards make toxic brew for the evil queen and jack.",
  "Happy wizards make toxic brew for the evil queen and jack. Back in June we delivered oxygen equipment of the same size.",
  "Back in June we delivered oxygen equipment of the same size. Just keep examining every low bid quoted for zinc etchings.",
  "Just keep examining every low bid quoted for zinc etchings. A quick movement of the enemy will jeopardize six gunboats.",
  "A quick movement of the enemy will jeopardize six gunboats. All questions asked by five watched experts amaze the judge.",
  "All questions asked by five watched experts amaze the judge. The wizard quickly jinxed the gnomes before they vaporized.",
  "The wizard quickly jinxed the gnomes before they vaporized. Jim quickly realized that beautiful gowns are expensive.",
  "Jim quickly realized that beautiful gowns are expensive. Nymphs blitz quick vex dwarf jog."
];

function getRandomPangram() {
  return pangrams[Math.floor(Math.random() * pangrams.length)];
}

function initPangrams() {
  const typeTester = document.getElementById('fonts-type-tester');
  const samples = document.querySelectorAll('.fonts__sample');

  // Assign random pangrams and store them for restoration
  samples.forEach(sample => {
    const randomPangram = getRandomPangram();
    sample.dataset.pangram = randomPangram;
    sample.innerHTML = randomPangram;
  });

  // Also handle any other .changepan elements (non-font samples)
  document.querySelectorAll('.changepan:not(.fonts__sample)').forEach(el => {
    el.innerHTML = getRandomPangram();
  });

  // Handle type tester input
  if (typeTester) {
    typeTester.addEventListener('input', function() {
      const customText = this.value;
      if (customText.trim()) {
        samples.forEach(sample => {
          sample.innerHTML = customText;
        });
      } else {
        // Restore pangrams when input is cleared
        samples.forEach(sample => {
          sample.innerHTML = sample.dataset.pangram;
        });
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPangrams);
} else {
  initPangrams();
}

export { pangrams, getRandomPangram, initPangrams };
